export const DOCUMENT_TYPE_NATIONAL_ID = 'national_id';
export const DOCUMENT_TYPE_DRIVERS_LICENSE = 'drivers_license';

export type FormDocumentType = 'national_id' | 'drivers_license' | '';

export const normalizeDocumentType = (value?: string | null): FormDocumentType => {
  if (value === 'national_id') {
    return 'national_id';
  }

  if (value === 'drivers_license' || value === 'driver_licence') {
    return 'drivers_license';
  }

  return '';
};

export const ownerFromBelongsToShareholder = (
  value?: boolean | number | string | null,
  fallback?: string | null
): 'self' | 'other' | '' => {
  if (value === true || value === 1 || value === '1' || value === 'true') {
    return 'self';
  }

  if (value === false || value === 0 || value === '0' || value === 'false') {
    return 'other';
  }

  if (fallback === 'self' || fallback === 'other') {
    return fallback;
  }

  return '';
};

export const belongsToShareholderFromOwner = (owner?: string): boolean | undefined => {
  if (owner === 'self') {
    return true;
  }

  if (owner === 'other') {
    return false;
  }

  return undefined;
};

export const toShareholderPersonalMetaPayload = (payload: {
  documentType?: string;
  addressProofOwner?: string;
  addressProofKinship?: string;
}) => {
  const belongsToShareholder = belongsToShareholderFromOwner(payload.addressProofOwner);

  return {
    document_type: payload.documentType || undefined,
    belongs_to_shareholder: belongsToShareholder,
    relationship_degree:
      belongsToShareholder === false
        ? payload.addressProofKinship || undefined
        : belongsToShareholder === true
          ? null
          : undefined
  };
};
